import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Lenis from "lenis";
import MethodPage from "@/components/landing/MethodPage";
import PlatformPage from "@/components/landing/PlatformPage";
import HowPage from "@/components/landing/HowPage";
import DiferenciaisPage from "@/components/landing/DiferenciaisPage";
import AudiencePage from "@/components/landing/AudiencePage";
import AdminLeads, { AuthCallback } from "@/components/landing/AdminLeads";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function AppRouter() {
  const location = useLocation();
  // Detecta o retorno do Google OAuth de forma síncrona (evita condição de corrida)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<PlatformPage />} />
        <Route path="/metodo" element={<MethodPage />} />
        <Route path="/plataforma" element={<Navigate to="/" replace />} />
        <Route path="/como-funciona" element={<HowPage />} />
        <Route path="/diferenciais" element={<DiferenciaisPage />} />
        <Route path="/para-quem" element={<AudiencePage />} />
        <Route path="/admin" element={<AdminLeads />} />
      </Routes>
    </>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <AppRouter />
    </BrowserRouter>
  );
}

export default App;
